jQuery( document ).ready( function($) {

	// slick slider
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true,
		arrows: false,
	});

	$( '.slide-apartments' ).slick({
		speed: 1000,
		autoplay: false,
		fade: true,
		arrows: true
	});

	$( '.slide-content' ).slick({
		speed: 1000,
		autoplay: false,
		fade: true,
		arrows: true
	});

	$( '.slide-gallery' ).slick({
		speed: 1000,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			}
		]
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.navigation' ).toggleClass( 'slidein' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.page-overlay' ).toggleClass( 'show' );
	});

	// reveal the contact widget
	$( '.j-show-contact' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.head-widget' ).toggleClass( 'slidein' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.page-overlay' ).toggleClass( 'show' );
	});

	// add arrow to dropdown menu items
	$( '.menu-item-has-children' ).prepend( '<span></span>' );

	// toggle the sub menu
	$( '.menu-item-has-children' ).on( 'click', 'span', function(e) {
		$( this ).closest( 'li' ).find( '.submenu' ).toggleClass( 'shown' );
	});

	// Slider down arrow
	$( '.scrolldown' ).on( 'click', function(e) {
		e.preventDefault();

		var target = $('#content');
		$( 'html, body' ).stop().animate({
			scrollTop: target.offset().top - 59
		}, 800 );
	});

	// reveal the booking form
	$( '.j-book-room > a' ).on( 'click', function(e) {
 		e.preventDefault();

 		$( '#booking-modal' ).foundation( 'open' );
 		// $( '.book-form' ).toggleClass( 'slidein' );
	});

	// hide the booking form
	$( '.j-close-book' ).on( 'click', function(e) {
 		e.preventDefault();

 		$( '.book-form' ).removeClass( 'slidein' );
	});

	// show best rate box
	$( '.best-rate h5' ).on( 'click', function(e) {
		e.preventDefault();

		var $this = $(this).closest( '.best-rate' );

		if ( $this.hasClass( 'opened' ) ) {
			$this.addClass( 'closed' ).removeClass( 'opened' );
		} else {
			$this.addClass( 'opened' ).removeClass( 'closed' );
		}
	});

	$( '.best-rate.opened > a' ).on( 'click', function(e) {
		e.preventDefault();
		$( '.best-rate' ).addClass( 'closed' );
	});

	// reveal the expand block row
	$( '.j-reveal' ).on( 'click', function(e) {
		e.preventDefault();

		$(this).toggleClass( 'opened' );
		$(this).closest( '.block-wrap' ).find( '.reveal-block' ).slideToggle();
	});

	// accordion on wedding page
	$( '.accordion-title' ).on( 'click', function(e) {
		e.preventDefault();

		$(this).toggleClass( 'opened' );
		$(this).closest( '.accordion-item' ).find( '.accordion-content' ).slideToggle();
	});

	// show newsletter modal
	if ( $( 'body' ).hasClass( 'blog' ) ) {
		var $modal = $( '#newsletter-modal' ); //define your variables
		var delay = 20000;

		//check if session variable exists.
		//If NOT then call your function.
		if ( !sessionStorage.getItem( 'is_already_opened_once' ) ) { 
			modalHandler($modal,delay);//call your function
		}

		function modalHandler($modal,delay){
			// $modal.foundation('open');
			setTimeout(function(){
				$modal.foundation( 'open' );
				//set the session_variable
				sessionStorage.setItem( 'is_already_opened_once', true );
			},delay);
		}
	};

	// show booking modal
	if ( $( 'body' ).hasClass( 'page-apartments' ) ) {
		var $booknow = $( '#booking-modal' ); //define your variables
		var delay = 20000;

		if ( !sessionStorage.getItem( 'booking_opened_once' ) ) { 
			modalHandler($booknow,delay);//call your function
		}

		function modalHandler($modal,delay){
			// $modal.foundation('open');
			setTimeout(function(){
				$booknow.foundation( 'open' );
				//set the session_variable
				sessionStorage.setItem( 'booking_opened_once', true );
			},delay);
		}
	};

	// Booking widget
	if ( $( 'body' ).hasClass( 'page-bartons-yard-cafe-bar-carlisle' ) ) {
		$(function() {
			var widgetFrame = $( '#rd-widget-frame' );
			widgetFrame.load( 'https://booking.resdiary.com/widget/Standard/BartonsYard/9071' );
		});
	};

	if ( $( 'body' ).hasClass( 'page-penny-blue' ) ) {
		$(function() {
			var widgetFrame = $( '#rd-widget-frame' );
			widgetFrame.load( 'https://booking.resdiary.com/widget/Standard/PennyBlue/2200' );
		})
	};

	if ( $( 'body' ).hasClass( 'page-afternoon-tea-carlisle' ) ) {
		$(function() {
			var widgetFrame = $( '#rd-widget-frame' );
			widgetFrame.load( 'https://booking.resdiary.com/widget/Standard/BartonsYard/9166' );
		})
	};

	// animate in scroll effect
	(function($) {

		/**
		* Copyright 2012, Digital Fusion
		* Licensed under the MIT license.
		* http://teamdf.com/jquery-plugins/license/
		*
		* @author Sam Sehnert
		* @desc A small plugin that checks whether elements are within
		*     the user visible viewport of a web browser.
		*     only accounts for vertical position, not horizontal.
		*/

		$.fn.visible = function(partial) {

		  var $t            = $(this),
			  $w            = $(window),
			  viewTop       = $w.scrollTop(),
			  viewBottom    = viewTop + $w.height(),
			  _top          = $t.offset().top +50,
			  _bottom       = _top + $t.height(),
			  compareTop    = partial === true ? _bottom : _top,
			  compareBottom = partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

		};
		
	})(jQuery);

	var win = $(window);

	var allMods = $( '.animate-in, .animate-left, .animate-right' );

	allMods.each(function(i, el) {
	  var el = $(el);
	  if (el.visible(true)) {
		el.addClass( 'fully-visible' ); 
	  } 
	});

	win.scroll(function(event) {
	  
	  allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
		  el.addClass( 'visible' ); 
		} 
	  });
	  
	});

});